import { Component, Input, OnInit } from '@angular/core';

import { faAnalytics, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'dx-featured-reports',
  templateUrl: './featured-reports.component.html',
  styleUrls: ['./featured-reports.component.scss']
})
export class FeaturedReportsComponent implements OnInit {
  @Input() allRoute: string;
  faAnalytics = faAnalytics;
  faChevronRight = faChevronRight;

  constructor() { }

  ngOnInit(): void {
  }

}
